// FAQ accordion — binds every .klik-faq-item on the page. Items are
// flagged once bound so nothing ever double-binds.

export default function initFaqAccordions(root = document) {
  const items = root.querySelectorAll('.klik-faq-item');
  if (!items.length) return;

  items.forEach((item) => {
    if (item._klikFaqBound) return;

    const question = item.querySelector(':scope > .klik-faq-item__question');
    if (!question) return;

    item._klikFaqBound = true;

    question.setAttribute('role', 'button');
    question.setAttribute('tabindex', '0');
    question.setAttribute('aria-expanded', 'false');

    function toggle() {
      const isOpen = item.classList.toggle('is-open');
      question.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    question.addEventListener('click', toggle);
    question.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
    });
  });
}
